// test1126
(1126 && 0);
